module.exports = __webpack_public_path__ + "img/西瓜6.63a5de80.png";